import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ChatState {
  messageWithTeacher: string;
  messageWithStudents: string;
  isChatWithTeacherDisabled: boolean;
  isChatWithStudentsDisabled: boolean;
  setMessageWithTeacher: (messageWithTeacher: string) => void;
  setMessageWithStudents: (messageWithStudents: string) => void;
  setIsChatWithTeacherDisabled: (isDisabled: boolean) => void;
  setIsChatWithStudentsDisabled: (isChatWithStudentsDisabled: boolean) => void;
}

const useChatState = create<ChatState>()(
  devtools(
    (set) => ({
      messageWithTeacher: "",
      messageWithStudents: "",
      isChatWithTeacherDisabled: true,
      isChatWithStudentsDisabled: true,
      setMessageWithTeacher: (messageWithTeacher) =>
        set({ messageWithTeacher }),
      setMessageWithStudents: (messageWithStudents) =>
        set({ messageWithStudents }),
      setIsChatWithTeacherDisabled: (isChatWithTeacherDisabled) =>
        set({ isChatWithTeacherDisabled }),
      setIsChatWithStudentsDisabled: (isChatWithStudentsDisabled) =>
        set({ isChatWithStudentsDisabled }),
    }),
    {
      name: "chat-state",
    },
  ),
);

export default useChatState;
